module.exports = __webpack_public_path__ + "img/swiperbanner3.40026793.png";